<template>
    <form id="onboarding-de" class="wrapper tab-how" role="form" method="post" @submit.prevent="">
        <learnt-about-vitadio-form @clicked="nextTab()"></learnt-about-vitadio-form>
    </form>
</template>

<script>
    export default {
        methods: {
            nextTab() {
                this.$emit('clicked', 'email')
            }
        }
    }
</script>